import React, { FC } from 'react';
import ContainedButton from '../ContainedButton';
import { View } from 'react-native';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import HeaderOne from '../HeaderOne';
import Link from '../Link';
import styles from './styles';

export type ConnectToSpotifyProps = {
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;

  /**
   * onPress handler
   */
  onPress: (e: any) => void;
};
export const ConnectToSpotify: FC<ConnectToSpotifyProps> = ({ onPress }) => {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <HeaderOne title="Connect To Listen" />
      </View>
      <GalanoGrotesqueText style={styles.title}>
        Connect your premium Spotify account to proceed
      </GalanoGrotesqueText>
      <View style={styles.buttonContainer}>
        <ContainedButton
          style={styles.connectButton}
          title="Connect Spotify"
          onPress={onPress}
        />
        <GalanoGrotesqueText style={styles.signup}>
          Don't have a premium Spotify account?
        </GalanoGrotesqueText>
        <Link
          text="Sign up"
          onPress={() => {}}
          url="https://www.spotify.com/us/premium/"
        />
      </View>
    </View>
  );
};

export default ConnectToSpotify;
